import { render, staticRenderFns } from "./AlertError.vue?vue&type=template&id=2bdcd66d&scoped=true"
import script from "./AlertError.vue?vue&type=script&lang=js"
export * from "./AlertError.vue?vue&type=script&lang=js"
import style0 from "./AlertError.vue?vue&type=style&index=0&id=2bdcd66d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdcd66d",
  null
  
)

export default component.exports